import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo.png";
import "./sideDrawer.css";

export default function SideDrawer(props) {
  return (
    <div>
      <div className="navbar-brand">
        <img src={logo} alt="MTS" className="logo img-responsive sideDrawerLogo"/>
      </div>
      <ul>
        <li className="firstListItem">
          <Link
            to="/dashboard"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-home drawerIcon" />
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/jobs"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-calendar-alt drawerIcon" />
            Jobs
          </Link>
        </li>

        <li>
          <Link
            to="/dashboard/reports"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-chart-bar drawerIcon" />
            Reports
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/employees"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-users drawerIcon" />
            Employees
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/archived-jobs"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-calendar-alt drawerIcon" />
            Archived Jobs
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/maintenance"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-wrench drawerIcon" />
            Maintenance
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/account"
            onClick={() => {
              props.click();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-user-alt drawerIcon" />
            Account
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/employees"
            onClick={() => {
              props.logOut();
            }}
            className="drawerNavLink"
          >
            <i className="fas fa-sign-out-alt drawerIcon" />
            Log Out
          </Link>
        </li>
      </ul>
    </div>
  );
}
